import type { Model, Sub2APIBootstrap } from '$lib/stores';

type Sub2APIManagedModel = {
	id?: unknown;
	display_name?: unknown;
	capabilities?: Record<string, unknown> | null;
};

export const sub2APIModelToOpenWebUIModel = (model: Sub2APIManagedModel): Model => {
	const capabilities = model?.capabilities ?? {};
	const id = `${model?.id ?? ''}`;
	const name = `${model?.display_name ?? model?.id ?? ''}`;
	const fileInput = capabilities.file_input ?? true;
	const maxFilesPerMessage = capabilities.max_files_per_message ?? (fileInput === false ? 0 : 10);

	return {
		id,
		name,
		object: 'model',
		owned_by: 'sub2api',
		sub2api_managed: true,
		info: {
			meta: {
				capabilities: {
					vision: capabilities.image_input ?? true,
					file_upload: fileInput,
					web_search: capabilities.web_search ?? false,
					image_generation: capabilities.image_generation ?? false,
					code_interpreter: capabilities.code_interpreter ?? false,
					sub2api_allowed_reasoning_efforts: capabilities.allowed_reasoning_efforts ?? ['none'],
					sub2api_default_reasoning_effort: capabilities.default_reasoning_effort ?? 'none',
					sub2api_max_files_per_message: maxFilesPerMessage,
					sub2api_max_file_mb: capabilities.max_file_mb ?? 20,
					sub2api_image_generation_qualities: capabilities.image_generation_qualities ?? [
						'low',
						'medium',
						'high',
						'auto'
					],
					sub2api_image_generation_quality: capabilities.image_generation_quality ?? 'auto',
					sub2api_unlimited: capabilities.unlimited ?? false,
					usage: true,
					terminal: false
				},
				defaultFeatureIds: []
			}
		}
	} as unknown as Model;
};

export const sub2APIBootstrapModelsToOpenWebUIModels = (
	bootstrap: Pick<Sub2APIBootstrap, 'models'> | null | undefined
) => ((bootstrap?.models ?? []) as Sub2APIManagedModel[]).map(sub2APIModelToOpenWebUIModel);

export const sub2APIManagedModelsOrCurrent = ({
	bootstrap,
	currentModels
}: {
	bootstrap: Pick<Sub2APIBootstrap, 'models'> | null | undefined;
	currentModels: Model[];
}) => {
	if (!bootstrap) {
		return currentModels;
	}

	return sub2APIBootstrapModelsToOpenWebUIModels(bootstrap);
};
